/* eslint-disable */ import { memoEval, replaceEntityRecipesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const cornerCountersinkHolesComponents = [
    attachComponent.withComponent(replaceEntityRecipesComponent, 'default', true).withEntity('CornerCountersinkHoles').attach(memoEval((self)=>[
            self.$cornerBoltHolesRecipes
        ], ($cornerBoltHolesRecipes)=>({
            recipes: $cornerBoltHolesRecipes,
            keepChildren: true
        })))
];

//# sourceMappingURL=corner-countersink-holes.js.map